/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Global styles needed for CSS Custom Highlight API
import { css, Global, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

const rendererHighlightStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- ::highlight() pseudo-element required for CSS Custom Highlight API
	'::highlight(remix-thinking-renderer)': {
		backgroundColor: token('color.background.accent.purple.subtler'),
		textDecoration: 'underline',
		textDecorationStyle: 'dotted',
		textDecorationThickness: token('space.025'),
		textDecorationColor: token('color.border.accent.purple'),
		textDecorationSkipInk: 'none',
	},
});

/**
 * Injects the global ::highlight() CSS rule that styles the persistent
 * selection created by useRendererRemixHighlight. Render once at the
 * page level (e.g. alongside the renderer content).
 */
export const RendererRemixHighlightStyles = (): React.ReactElement => {
	return (
		<React.Fragment>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Global CSS Custom Highlight API styles */}
			<Global styles={rendererHighlightStyles} />
		</React.Fragment>
	);
};
